module.exports = __webpack_public_path__ + "img/more5.efd72078.png";